import { css } from "@emotion/react";

export const layoutCss = (spaceY: number, spaceX: number) =>
  css({
    padding: `${spaceY}px ${spaceX}px`,
  });
